import { useAppDispatch, useAppState } from 'Context/AppContext/AppContext'
import { DonationInterval, PlatformPlan } from 'Generated/graphql-types'
import { ApolloError, useLazyQuery } from '@apollo/client'
import GET_NONPROFIT_ORG_DONATIONS_DETAILS_QUERY from 'Apollo/Queries/GetNonprofitOrgDonationsDetails'
import { useEffect } from 'react'
import { UPDATE_NONPROFIT_DONATION_DETAILS } from 'TypeDefs/AppContext'
import { useAuth0 } from '@auth0/auth0-react'
import { useLogging } from 'Hooks/useLogging'

const useDonationDetails = () => {
  const {
    nonprofitOrgConfig: { orgId, platformPlan },
  } = useAppState()
  const { user } = useAuth0()
  const email = user?.email
  const dispatch = useAppDispatch()
  const logger = useLogging('useDonations')
  const [getDonationDetails, { loading }] = useLazyQuery<any>(
    GET_NONPROFIT_ORG_DONATIONS_DETAILS_QUERY,
    {
      // fetchPolicy: 'cache-and-network',
      variables: { nonprofitOrgId: orgId },
      context: { clientName: 'batched' },
      onCompleted: (data) => {
        const hasRecurringAccess = platformPlan !== PlatformPlan.Starter
        const availableFrequencies =
          platformPlan === PlatformPlan.Starter
            ? [DonationInterval.OneTime]
            : [DonationInterval.OneTime, DonationInterval.Monthly]

        dispatch({
          type: UPDATE_NONPROFIT_DONATION_DETAILS,
          donationDetails: {
            availableFrequencies,
            hasRecurringAccess,
            state: data?.nonprofitOrgDonationsDetails?.state,
            loading,
          },
        })
      },
      onError: (err: ApolloError) => {
        logger.error(err)
      },
    }
  )

  useEffect(() => {
    if (orgId) {
      getDonationDetails()
    }
  }, [getDonationDetails, email, orgId])
}

export default useDonationDetails
